var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFsLcArrow = function SvgFsLcArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    fill: "none",
    viewBox: "0 0 26 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    d: "m14.964.558-3.168 2.664 6.984 7.344H.744v3.816H18.78l-6.984 7.344 3.168 2.664 10.728-11.916z"
  })));
};
export { SvgFsLcArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNiAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0Ljk2NDEgMC41NTc2MTdMMTEuNzk2MSAzLjIyMTZMMTguNzgwMSAxMC41NjU2SDAuNzQ0MTQxVjE0LjM4MTZIMTguNzgwMUwxMS43OTYxIDIxLjcyNTZMMTQuOTY0MSAyNC4zODk2TDI1LjY5MjEgMTIuNDczNkwxNC45NjQxIDAuNTU3NjE3WiIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";